const LISTE_FACTOR = {
  title: 'Liste des factors',
  breadcrumb: {
    liste: 'Liste des factors',
  },
  actions: {
    add: 'Nouveau factor',
  },
  tab: {
    code: 'Code',
    raisonSocial: 'Raison sociale',
    adresse: 'Adresse',
    cp: 'CP',
    ville: 'Ville',
    telephone: 'Téléphone',
    portable: 'Portable',
    email: 'Email',
    compteComptable: 'Code comptable',
  },
  archivage: {
    titleDesarchiver: 'Etes-vous sûr de vouloir désarchiver ce factor ?',
    title: 'Etes-vous sûr de vouloir archiver ce factor ?',
    sucessArchivage: 'Factor archivé avec succès',
    sucessDesarchivage: 'Factor désarchivé avec succès',
  },
  filtre: {
    factor: 'Factor(s)',
    archive: 'Archivé',
  },
};

export default LISTE_FACTOR;
